<template>
  <div
    id="ssr-page"
    class="ssr-page"
    :class="[
      lang,
      {
        landscape: isLandscape,
        'transparent-bg-mode': isTransparentBgMode
      }
    ]"
  >
    <transition :name="transitionName">
      <keep-alive>
        <router-view></router-view>
      </keep-alive>
    </transition>
  </div>
</template>
<script>
import globalConfig from '@utiles/officialStore/globalConfig';
import {
  GET_PAY_PAGE_INFO,
  UPDATE_IS_LANDSCAPE
} from '@store/officialTopupNew/page';
import { mapState } from 'vuex';
import { justifyLandscape } from '@store/officialTopupNew/ultile';
import { isPhone } from '@utiles/device';
import { isSafari } from '@utiles/officialStore/device';
import transparentBg from '@mixins/officialTopupNew/transparentBg';
import { resetStartTime } from '@utiles/officialTopupNew/speedPoint';

const initColorConfig = colorConfig => {
  Object.keys(colorConfig).forEach(item => {
    document.documentElement.style.setProperty(`--${item}`, colorConfig[item]);
    document.body.style.setProperty(`--${item}`, colorConfig[item]);
  });
};
export default {
  mixins: [transparentBg],
  data() {
    return {
      transitionName: ''
    };
  },
  computed: {
    ...mapState({
      letter: state => state.letter,
      lang: state => state.lang,
      gameId: state => state.gameId,
      colorConfig: state => state.page.colorConfig,
      picList: state => state.page.picList,
      isLandscape: state => state.page.isLandscape
    })
    // isSafariHomePage() {
    //   return isSafari() && this.$route.name === 'home';
    // }
  },
  beforeCreate() {
    resetStartTime();
  },
  methods: {
    previewColorConfig() {
      if (globalConfig.getHrefParam('preview') == 1) {
        window.addEventListener('message', e => {
          try {
            const msg = JSON.parse(e?.data);
            console.log(msg);
            if (msg?.action === 'updateColor') {
              initColorConfig(msg?.data);
            }
            if (msg?.action === 'updateZoom') {
              document.body.style.zoom = msg?.data;
            }
            if (msg?.action === 'reload') {
              window.location.reload();
            }
          } catch (_e) {}
        });
      }
    }
  },
  async created() {
    const payPageInfo = await this.$store.dispatch(GET_PAY_PAGE_INFO);
    // domain限定处理
    if (
      !payPageInfo ||
      !payPageInfo.DOMAIN_LIST.includes(globalConfig.getMainHost())
    ) {
      globalConfig.jumpErrorPage({
        jump404Reason: 'domain_not_match_or_no_page_info',
        domain: globalConfig.getMainHost(),
        payPageInfo: !!payPageInfo,
        domainList: payPageInfo?.DOMAIN_LIST?.join(',') || ''
      });
      return;
    }
    // 语言处理
    const preLanguage = globalConfig.getHrefParamUndecode('language');
    if (preLanguage) {
      globalConfig.setLclStorageItem(
        globalConfig.getPageLangStorageKey(),
        preLanguage
      );
    }
    // 颜色配置处理
    initColorConfig(this.colorConfig);
    // 页签处理
    globalConfig.setPageTitleAndIco(
      this.letter?.v3OfficialTopUpCenterTitle || '',
      this.picList?.icon || ''
    );

    // SEO 特殊处理
    let keywords = document.querySelector('meta[name="keywords"]');
    keywords.content = this.letter?.v3OfficialTopUpCenterKeyword || '';
    let description = document.querySelector('meta[name="description"]');
    description.content = this.letter?.v3OfficialTopUpCenterDescription || '';
    // 路由处理
    globalConfig.setRouterQuery(this.$route.query);
    globalConfig.setRoute(this.$route);
    globalConfig.init();

    // 是否是增加移动端设备类名标识
    try {
      isPhone() && document.body.classList.add('is-phone');
    } catch (error) {
      console.error(error);
    }
  },
  mounted() {
    let timer = null;
    const handleResize = () => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        this.$store.commit(
          UPDATE_IS_LANDSCAPE,
          // 仅当宽高比大于1.2（即宽度>高度的1.2倍）时才视为横屏
          justifyLandscape()
        );
      }, 200);
    };
    if (isPhone()) {
      // 监听横竖屏变化
      window.addEventListener('orientationchange', handleResize);
    } else {
      window.addEventListener('resize', handleResize);
    }

    this.previewColorConfig();
  }
};
</script>
<style>
html {
  width: 100%;
  height: 100%;
}
body {
  margin: 0;
  width: 100%;
  height: 100%;
}
.ssr-page {
  width: 100%;
  height: 100%;
  font-size: 0;
}
#ssr-page.transparent-bg-mode {
  overflow: hidden;
}
#ssr-page.safari-home-fixed {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: auto;
}
</style>
<style lang="scss">
@import '@assets/scss/officialTopupNew/base.scss';
@import '@assets/scss/officialTopupNew/animate.scss';
@import '@assets/scss/officialTopupNew/common.scss';
@import '@assets/scss/officialTopupNew/officialTopupNew.scss';
@import '@assets/scss/officialTopupNew/cash.scss';
</style>
